import { useCallback } from 'react';
import { MediaObject } from 'src/api/services/MediaClient';
import { useToggle } from 'src/helpers/useToggle';
import { Api } from 'src/api';
import { download as fallbackDownload } from 'src/lib/utils';

const useMediaDownload = () => {
  const [isDownloading, , toggle] = useToggle();

  const downloadAll = useCallback(async (media: MediaObject[]) => {
    toggle();
    try {
      for (const m of media) {
        if (!m.id) continue;
        try {
          const { download_url } = await Api.media.getDownloadUrl(m.id);
          window.open(download_url, '_blank');
        } catch {
          // Fallback to legacy fetch+blob if the endpoint is unavailable
          if (m.index_url) {
            await fallbackDownload(m.index_url);
          }
        }
      }
    } finally {
      toggle();
    }
  }, []);

  return {
    downloadAll,
    isDownloading,
  };
};

export { useMediaDownload };
